import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { countryBankApi } from "./api";
import { useLocation } from "react-router";

const MyContext = createContext();

export const useMyContext = () => {
  return useContext(MyContext);
};

export const MyContextProvider = ({ children }) => {
  const [username, setUsername] = useState("");
  const [remitterUserId, setRemitterUserId] = useState(null);
  const [remitterBankId, setRemitterBankId] = useState(null);
  const [studentUserId, setStudentUserId] = useState(null);
  const [beneficiaryUserId, setBeneficicaryUserId] = useState(null);
  const [beneficiryBankId, setBeneficiaryBankId] = useState(null);
  const [showkyc, setShowKyc] = useState(true);
  const [remitterSecondFlow, setRemitterSecondFlow] = useState(false);
  const [remitterBankSecondFlow, setRemitterBankSecondFlow] = useState(false);
  const [selectedRemitterBank, setSelectedRemitterBank] = useState(null);
  const [remitterBankCardSelection, setRemitterBankCardSelection] =
    useState(false);
  const [studentSecondFlow, setStudentSecondFlow] = useState(false);
  const [beneficiarySecondFlow, setBeneficiarySecondFlow] = useState(false);
  const [beneficiaryBankSecondFlow, setBeneficiaryBankSecondFlow] =
    useState(false);
  const [selectedBeneficiaryBank, setSelectedBeneficiaryBank] = useState(null);
  const [completedRemitter, setCompletedRemitter] = useState(false);
  const [completedStudent, setCompletedStudent] = useState(false);
  const [completedBeneficiary, setCompletedBeneficiary] = useState(false);
  const [transactionId, setTransactionId] = useState(null);
  const [isCompleted, setIsCompleted] = useState(false);
  const [purposeId, setPurposeId] = useState("");
  const [acceptTandCofPurpose, setAcceptTandCofPurpose] = useState(false);
  const [isEducationLoanCheck, setIsEducationLoanCheck] = useState(false);
  const [isConfirmedCheck, setIsConfirmedCheck] = useState(false);
  const [showStudentUpload, setShowStudentUpload] = useState(true);
  const [hashId, setHashId] = useState("");
  const [purpose, setPurpose] = useState("");
  const [listReuploadDocuments, setListReuploadDocuments] = useState([]);
  const [showkycDetail, setShowKycDetail] = useState(false);
  const [stepToShow, setStepsToShow] = useState("RemitterStep1");
  const [showRemitterDetail, setShowRemitterDetail] = useState(false);
  const [showRemitterBankDetail, setShowRemitterBankDetail] = useState(false);
  const [showStudentDetail, setShowStudentDetail] = useState(false);
  const [showPassportDetail, setShowPassportDetail] = useState(false);
  const [showBeneficiaryDetail, setShowBeneficiaryDetail] = useState(false);
  const [showBeneficiaryBankDetail, setShowBeneficiaryBankDetail] =
    useState(false);
  const [beneficiaryBankCardSelection, setBeneficiaryBankCardSelection] =
    useState(false);
  const [userStatus, setUserStatus] = useState(null);
  const [countryObject, setCountryObject] = useState(null);
  const [isLoggedIn, setLoggedIn] = useState();
  const [isForgotRoute, setIsForgotRoute] = useState(false);
  const [offlineTransactionFlow, setOfflineTransactionFlow] = useState(false);
  const [remitterShortDetail, setRemitterShortDetail] = useState({
    name: "",
    phone: "",
    email: "",
    dob: "",
    address: "",
    city: "",
    state: "",
    postalcode: "",
    country: "India",
  });
  const [shortRemitterBankDetail, setShortRemitterBankDetail] = useState({
    accountHolderName: "",
    accountMasked: "",
    bankName: "",
  });
  const [studentShortDetail, setStudentShortDetail] = useState({
    name: "",
    phone: "",
    email: "",
    dob: "",
    address: "",
    city: "",
    state: "",
    postalcode: "",
    country: "India",
  });
  const [beneficiaryShortDetail, setBeneficiaryShortDetail] = useState({
    name: "",
    phone: "",
    email: "",
    dob: "",
    address: "",
    city: "",
    state: "",
    postalcode: "",
    country: "",
  });
  const [shortBeneficiaryBankDetail, setShortBeneficiaryBankDetail] = useState({
    accountHolderName: "",
    accountMasked: "",
    bankName: "",
    swiftCode: "",
  });
  const location = useLocation();
  // themeAPI
  const defaultThemeColor = "#0061d3";
  const [themeColor, setThemeColor] = useState("");
  const [siteLogo, setSiteLogo] = useState("");
  const [partnerCode, setPartnerCode] = useState("");
  const [partnerEmail, setPartnerEmail] = useState("--");
  const [contactNumber, setContactNumber] = useState("--");
  const [toc, setToc] = useState("");
  const [siteDisclaimerLink, setsSiteDisclaimerLink] = useState("");
  const [loadingLogo, setLoadingLogo] = useState(false);
  const [planId, setPlanId] = useState("");
  const [redirectionLink, setRedirectionLink] = useState("");
  const [CountryMapping, setCountryMapping] = useState([]);
  const [remitterOfflineDetail, setRemitterOfflineDetail] = useState({
    name: "",
    phone: "",
    email: "",
    pan: "",
  });
  const [studentOfflineDetail, setStudentOfflineDetail] = useState({
    name: "",
    phone: "",
    email: "",
    pan: "",
    // relation: ""
  });
  const [offlineRemitterUserId, setOfflineRemitterUserId] = useState("");
  const [offlineStudentUserId, setOfflineStudentUserId] = useState("");
  const [mcaUserSearch, setMcaUserSearch] = useState(false);
  const [remitterStatus, setRemitterStatus] = useState(null);
  const [remitterId, setRemitterId] = useState(null);

  const upadteUserId = (newVal) => {
    setRemitterUserId(newVal);
  };

  const logout = () => {
    setUsername("");
    setRemitterUserId(null);
    setRemitterBankId(null);
    setStudentUserId(null);
    setBeneficicaryUserId(null);
    setBeneficiaryBankId(null);
    setShowKyc(true);
    setRemitterSecondFlow(false);
    setRemitterBankSecondFlow(false);
    setSelectedRemitterBank(null);
    setRemitterBankCardSelection(false);
    setStudentSecondFlow(false);
    setBeneficiarySecondFlow(false);
    setBeneficiaryBankSecondFlow(false);
    setSelectedBeneficiaryBank(null);
    setCompletedRemitter(false);
    setCompletedStudent(false);
    setCompletedBeneficiary(false);
    setTransactionId(null);
    setIsCompleted(false);
    setShowKycDetail(false);
    setPurposeId("");
    setAcceptTandCofPurpose(false);
    setIsEducationLoanCheck(false);
    setIsConfirmedCheck(false);
    setShowStudentUpload(true);
    setHashId("");
    setPurpose("");
    setStepsToShow("RemitterStep1");
    setShowRemitterDetail(false);
    setShowRemitterBankDetail(false);
    setShowStudentDetail(false);
    setShowPassportDetail(false);
    setShowBeneficiaryDetail(false);
    setShowBeneficiaryBankDetail(false);
    setBeneficiaryBankCardSelection(false);
    setUserStatus(null);
    setCountryObject(null);
    setLoggedIn(false);
    setCountryMapping([]);
    setRemitterShortDetail({
      name: "",
      phone: "",
      email: "",
      dob: "",
      address: "",
      city: "",
      state: "",
      postalcode: "",
      country: "India",
    });
    setShortRemitterBankDetail({
      accountHolderName: "",
      accountMasked: "",
      bankName: "",
    });
    setStudentShortDetail({
      name: "",
      phone: "",
      email: "",
      dob: "",
      address: "",
      city: "",
      state: "",
      postalcode: "",
      country: "India",
    });
    setBeneficiaryShortDetail({
      name: "",
      phone: "",
      email: "",
      dob: "",
      address: "",
      city: "",
      state: "",
      postalcode: "",
      country: "India",
    });
    setShortBeneficiaryBankDetail({
      accountHolderName: "",
      accountMasked: "",
      bankName: "",
      swiftCode: "",
    });
    setRemitterOfflineDetail({
      name: "",
      phone: "",
      email: "",
      pan: "",
    });
    setOfflineTransactionFlow(false);
    setRemitterStatus(null);
    setRemitterId(null);
  };

  const fetchCountryDetails = async (partnerCode) => {
    if (!partnerCode) return;
    try {
      const resp = await countryBankApi(partnerCode);
      if (resp && resp.data) {
        setCountryMapping(resp.data);
      }
    } catch (error) {}
  };

  const hostUrl = process.env.REACT_APP_HOST;
  const RUBALPartnerCodeList = [process.env.REACT_APP_XOTIC_PARTNER_P1];

  const fetchTheme = async () => {
    let host = window.location.host;
    if (host.includes("www.")) host = host.replace("www.", "");
    if (
      host.includes("localhost") ||
      host.includes("ec2-3-80-137-66.compute-1.amazonaws.com")
    )
      host = hostUrl;
    try {
      let url = `${process.env.REACT_APP_BASE_API}/v1/client/theme-data/${host}`;
      const response = await axios.get(url);
      if (response.data.data) {
        setLoadingLogo(true);
        if (RUBALPartnerCodeList.includes(response.data.data.partnerCd)) {
          setOfflineTransactionFlow(true);
        }
        fetchCountryDetails(response.data.data.partnerCd);
        setSiteLogo(response.data.data.partnerLogoUrl);
        setPartnerEmail(response.data.data.partnerSupportEmail);
        setContactNumber(response.data.data.partnerSupportPhone);
        setsSiteDisclaimerLink(response.data.data.siteDisclaimerLink);
        setToc(response.data.data.termsAndConditionsLink);
        setMcaUserSearch(response.data.data.config.mcaUserSearch || false);
        if (response.data.data.themePrimaryColor) {
          setThemeColor(response.data.data.themePrimaryColor);
        } else {
          setThemeColor(defaultThemeColor);
        }
        setPlanId(response.data.data.defaultPlan);
        setPartnerCode(response.data.data.partnerCd);
        sessionStorage.setItem(
          "partnerShortCode",
          response.data.data.partnerShortCode
        );
        let requiredRedirectionLink = `https://${response.data.data.partnerLoginUrl}/redirecting`;
        setRedirectionLink(requiredRedirectionLink);
      } else {
        setLoadingLogo(true);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchTheme();
  }, [location.pathname]);

  // useEffect(() => {
  //   if (partnerCode) {
  //     fetchCountryDetails(partnerCode);
  //   }
  // }, [partnerCode]);

  useEffect(() => {
    document.documentElement.style.setProperty("--theme-color", themeColor);
  }, [themeColor]);

  return (
    <MyContext.Provider
      value={{
        remitterUserId,
        upadteUserId,
        remitterBankId,
        setRemitterBankId,
        studentUserId,
        setStudentUserId,
        beneficiaryUserId,
        setBeneficicaryUserId,
        beneficiryBankId,
        setBeneficiaryBankId,
        remitterSecondFlow,
        setRemitterSecondFlow,
        remitterBankSecondFlow,
        setRemitterBankSecondFlow,
        remitterBankCardSelection,
        setRemitterBankCardSelection,
        selectedRemitterBank,
        setSelectedRemitterBank,
        showkyc,
        setShowKyc,
        showkycDetail,
        setShowKycDetail,
        studentSecondFlow,
        setStudentSecondFlow,
        beneficiarySecondFlow,
        setBeneficiarySecondFlow,
        beneficiaryBankSecondFlow,
        setBeneficiaryBankSecondFlow,
        selectedBeneficiaryBank,
        setSelectedBeneficiaryBank,
        completedRemitter,
        setCompletedRemitter,
        completedStudent,
        setCompletedStudent,
        transactionId,
        setTransactionId,
        completedBeneficiary,
        setCompletedBeneficiary,
        isCompleted,
        setIsCompleted,
        logout,
        purposeId,
        setPurposeId,
        acceptTandCofPurpose,
        setAcceptTandCofPurpose,
        isEducationLoanCheck,
        setIsEducationLoanCheck,
        showStudentUpload,
        setShowStudentUpload,
        username,
        setUsername,
        hashId,
        setHashId,
        purpose,
        setPurpose,
        listReuploadDocuments,
        setListReuploadDocuments,
        remitterShortDetail,
        setRemitterShortDetail,
        shortRemitterBankDetail,
        setShortRemitterBankDetail,
        showRemitterDetail,
        setShowRemitterDetail,
        showRemitterBankDetail,
        setShowRemitterBankDetail,
        stepToShow,
        setStepsToShow,
        studentShortDetail,
        setStudentShortDetail,
        showStudentDetail,
        setShowStudentDetail,
        showPassportDetail,
        setShowPassportDetail,
        beneficiaryShortDetail,
        setBeneficiaryShortDetail,
        shortBeneficiaryBankDetail,
        setShortBeneficiaryBankDetail,
        showBeneficiaryDetail,
        setShowBeneficiaryDetail,
        showBeneficiaryBankDetail,
        setShowBeneficiaryBankDetail,
        beneficiaryBankCardSelection,
        setBeneficiaryBankCardSelection,
        isConfirmedCheck,
        setIsConfirmedCheck,
        userStatus,
        setUserStatus,
        countryObject,
        setCountryObject,
        siteLogo,
        loadingLogo,
        planId,
        partnerEmail,
        contactNumber,
        siteDisclaimerLink,
        toc,
        themeColor,
        partnerCode,
        redirectionLink,
        isLoggedIn,
        setLoggedIn,
        isForgotRoute,
        setIsForgotRoute,
        CountryMapping,
        setCountryMapping,
        remitterOfflineDetail,
        setRemitterOfflineDetail,
        studentOfflineDetail,
        setStudentOfflineDetail,
        offlineRemitterUserId,
        setOfflineRemitterUserId,
        offlineStudentUserId,
        setOfflineStudentUserId,
        offlineTransactionFlow,
        mcaUserSearch,
        remitterStatus,
        setRemitterStatus,
        remitterId,
        setRemitterId,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};
